import { AccordionDetails } from '@material-ui/core';
import styled from 'styled-components';

export const Styled = styled(AccordionDetails)`
  padding: 0;
`;
